<script setup lang="ts">
/**
 * État d'une enveloppe ou d'une échéance : icône + libellé, jamais la couleur seule (spec §8).
 * Pastille neutre, texte coloré : pas de fond coloré.
 */
import { fr } from '@/copy/fr'

import type { IconName } from '../icons/registry'
import Icon from './Icon.vue'

export type Status =
  'normal' | 'watch' | 'critical' | 'protected' | 'unfunded' | 'overdue' | 'due' | 'settled'

defineProps<{ status: Status }>()

const LOOK: Record<Status, { icon: IconName; tone: string }> = {
  normal: { icon: 'check', tone: 'text-positive' },
  watch: { icon: 'alert', tone: 'text-warn' },
  critical: { icon: 'alert', tone: 'text-danger' },
  protected: { icon: 'lock', tone: 'text-ink-muted' },
  unfunded: { icon: 'info', tone: 'text-ink-muted' },
  overdue: { icon: 'clock', tone: 'text-danger' },
  due: { icon: 'clock', tone: 'text-warn' },
  settled: { icon: 'check', tone: 'text-positive' },
}
</script>

<template>
  <span
    :class="[
      'inline-flex h-6 items-center gap-1 rounded-full bg-surface px-2 text-caption font-medium',
      LOOK[status].tone,
    ]"
  >
    <Icon :name="LOOK[status].icon" :size="16" />
    {{ fr.ui.status[status] }}
  </span>
</template>
